export default __webpack_public_path__ + "static/ww4-f1b92f0ba2e01b2cce05f33f43524e2b.jpg";